/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/***** ハンバーガーメニュー *****/

const HumEvent = () => {
  const HumTrigger = document.querySelector(".hum-btn")
  const HumMenu = document.querySelector(".hum-nav")
  const HumLink = document.querySelectorAll(".hum-link")

  HumTrigger.addEventListener("click", () => {
    HumTrigger.classList.toggle("is-active")
    HumMenu.classList.toggle("is-active")
  })

  HumLink.forEach(e =>{
    e.addEventListener("click", () => {
      HumTrigger.classList.remove("is-active")
      HumMenu.classList.remove("is-active")
    })
  })
}

HumEvent()



/***** スクロールアニメーション *****/

gsap.registerPlugin(ScrollTrigger);

/* 画像パララックス */

if( window.matchMedia("screen and (min-width:960px)").matches ) {
  gsap.utils.toArray('.js-parallax').forEach(wrap => {
    const y = wrap.getAttribute('data-y') || -60;

    gsap.to(wrap, {
      y: y,
      scrollTrigger: {
        trigger: wrap,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 0.5,
        //markers: true
      }
    })
  });
}

if( window.matchMedia("screen and (max-width:959px)").matches ) {
  gsap.utils.toArray('.js-parallax').forEach(wrap => {
    const y = wrap.getAttribute('data-y') || -30;

    gsap.to(wrap, {
      y: y,
      scrollTrigger: {
        trigger: wrap,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 0.5,
        //markers: true
      }
    })
  });
}

/* inviewアニメーション */

// フェード
$(function () {
  $(".js-fade").on("inview", function () {
    $(this).addClass("is-inview");
  });
});

$(function () {
  $(".js-fade-top_01").on("inview", function () {
    $(this).addClass("is-inview");
  });
});

$(function () {
  $(".js-fade-top_02").on("inview", function () {
    $(this).addClass("is-inview");
  });
});

// 上に移動しながらフェード
$(function () {
  $(".js-fadeUp").on("inview", function () {
    $(this).addClass("is-inview");
  });
});


